const ScrollableListView = (props) => {
  return (
    <div style={{ flex: 1, borderTop: "3px solid #EEEEEE" }}>
      {props.children}
    </div>
  );
};

export default ScrollableListView;
